// @flow
import React from 'react';
import styled from 'styled-components';

import { WarningIcon } from 'icons';

import theme from 'utils/theme';

export default function ErrorBox({ message, hasError = false }) {
    if (hasError) {
        return (
            <Wrapper>
                <WarningIcon name="attention-error" />
                <span>{message}</span>
            </Wrapper>
        );
    }
    return null;
}

const Wrapper = styled.div`
    color: ${() => theme.colors.error500};
    display: flex;
    text-align: left;

    span {
        margin: 0 5px;
    }

    svg {
        min-width: 15px;
    }
`;
